@let blok = block();
@let drawerActiveData = drawerActive();
@if (blok.content) {
    <button
        class=" md:!flex justify-center items-center cursor-pointer md:ml-auto mr-1 !overflow-visible"
        #openButton
        [attr.aria-label]="blok.ariaLabel"
        [attr.aria-describedby]="tooltipId"
        [attr.aria-expanded]="drawerActiveData"
        [attr.aria-controls]="tooltipId"
        (click)="drawer.toggle($event)">
        <mat-icon
            appTooltip
            class="cursor-pointer !overflow-visible"
            [ngClass]="getColorClass()"
            [class.text-secondary50]="!blok.color?.length || blok.color === ''"
            [tooltip]="renderedContent() || ''"
            [tooltipDisabled]="!blok.content"
            position="below"
            aria-hidden="false"
        >
            info
        </mat-icon>
    </button>
}

<div app-drawer
     #drawer
     [id]="tooltipId"
     role="tooltip"
     [isActive]="drawerActiveData"
     (isActiveChange)="drawerActive.set($event)"
>
    <div [innerHtml]="renderedContent()">
    </div>

</div>
